<p-table *ngIf="ptablepaidfees.length>0" #dt [columns]="cols" [value]="ptablepaidfees" dataKey="idx" rowExpandMode="multiple" [autoLayout]="true" [expandedRowKeys]="expandedRows">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width:35px;"></th>
      <th *ngFor="let col of columns">
        {{col.header}}
      </th>
    </tr>
    <tr>
      <th></th>
   
      <th *ngFor="let col of columns" [ngSwitch]="col.field">
        <div *ngSwitchCase="'year'" align="center" class="p-2">
          {{yearFilter}} - {{maxyear}}
          <i class="fa fa-times" title="Återställ" (click)="yearFilter=minyear;dt.filter(null, col.field, col.filterMatchMode)" style="cursor:pointer;font-size:9px;" *ngIf="yearFilter"></i>
          <p-slider [style]="{'width':'100%','margin-top':'8px'}" [(ngModel)]="yearFilter" [min]="minyear" [max]="maxyear" [animate]="true" (onChange)="onYearChange($event, dt)"></p-slider>
        </div>
        <i *ngSwitchCase="'totalAmountToPay'" class="fa fa-info-circle text-info" style="font-size:20px;font-weight:bold;" title="Medlemssavgift beräknad efter medlemskapets längd (antal månader) under året, eventuell rabatt och eventuell initieringsmånad."></i>
       
        <!--p-dropdown appendTo="body" *ngSwitchCase="'institutionShortName'" [options]="institutions" [style]="{'width':'100%'}" (onChange)="dt.filter($event.value, 'institutionShortName', 'equals')"></p-dropdown-->
      <p-select appendTo="body" *ngSwitchCase="'institutionShortName'" [options]="institutions" [style]="{'width':'100%'}" placeholder="Institution" class="w-full md:w-56" (change)="dt.filter($event.value, 'institutionShortName', 'equals')">
      <ng-template let-option pTemplate="item">
        {{ option.label === '' ? '– Välj –' : option.label }}
      </ng-template>
       <ng-template let-value pTemplate="selectedItem">
    {{ value?.label === '' ? '– Välj –' : value?.label }}
  </ng-template>
      </p-select>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-expanded="expanded" let-columns="columns">
    <tr [pSelectableRow]="rowData" [ngClass]="expanded ? 'exp' : ''">
      <td>
        <a *ngIf="rowData.payments?.length > 0" href="#" [pRowToggler]="rowData">
          <i [ngClass]="expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" style="font-size:10px;font-weight:bold;"><span style="margin-left:4px;color: grey;">{{rowData.payments?.length}}</span></i>
        </a>
      </td>
      <td *ngFor="let col of columns" style="height:40px;">
        <span *ngIf="col.field === 'institutionShortName'">
          <a [routerLink]="['/institutions/id/', rowData['institutionId']]" title="{{rowData['institutionName']}}">{{rowData[col.field]}}</a>
        </span>
        <span *ngIf="col.field !== 'isFullyPaid' && col.field !== 'institutionShortName' && col.field !== 'balance'">{{rowData[col.field]}}</span>
        <span *ngIf="col.field === 'balance'" [ngClass]="(col.field==='balance' && rowData[col.field] < 0) ? 'red' : 'black'">{{rowData[col.field]}}</span>
        <span *ngIf="col.field === 'isFullyPaid' && rowData[col.field] === true">
          <i class="fa fa-check" aria-hidden="true" style="color:green;"></i>
        </span>
        <span *ngIf="col.field === 'isFullyPaid' && rowData[col.field] === false">
          <i class="fa fa-times" aria-hidden="true" style="color:red;"></i>
        </span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
    <tr>
      <td [attr.colspan]="columns.length + 1" style="background-color: white;">
        <table class="table table-border" style="margin-left:16px;width:98%;border:1px solid dodgerblue;border-left:3px solid green;">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Summa</th>
            </tr>
          </thead>
          <tr *ngFor="let p of rowData.payments" class="paymentrow">
            <td>{{p.paidDate | date:'yyyy-MM-dd'}}</td>
            <td>{{p.paidAmount}}</td>
          </tr>
        </table>
      </td>
    </tr>
  </ng-template>
</p-table>